<script>
import Form from '@/components/ui/widgets/Form.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import ImpersonateModal from '@/components/customers/edit/customer-portal/ImpersonateModal.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-form-section-grid': FormSectionGrid,
    'mia-impersonate-modal': ImpersonateModal
  },

  data: () => ({
    showImpersonateModal: false
  }),

  computed: {
    ...mapGetters('customers', ['customer'])
  },

  mounted() {
    if (this.$route.query.impersonate === '1') {
      this.showImpersonateModal = true
    }
  }
}
</script>

<template>
  <div>
    <mia-form>
      <mia-form-section title="Anmeldung">
        <mia-form-section-grid>
          <div>
            <button
              type="button"
              class="inline-flex items-center px-4 py-2 mr-3 border-2 rounded text-orange-mia border-orange-mia focus:outline-none hover:bg-orange-mia-dark hover:text-white hover:border-orange-mia-dark"
              :disabled="$wait.any"
              @click="showImpersonateModal = true"
            >
              Anmeldelink generieren
            </button>

            <mia-impersonate-modal
              v-if="customer && showImpersonateModal"
              :show="showImpersonateModal"
              :customer-id="customer.id"
              @closed="showImpersonateModal = false"
            />
          </div>
        </mia-form-section-grid>
      </mia-form-section>
    </mia-form>
  </div>
</template>
